import React, {useState, useEffect} from 'react';
//Material-UI
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/styles';
//Icons
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles(theme => ({
   root: {
      height: '100%'
   },
   content: {
      padding: theme.spacing(1)
   },
   image: {
      height: 48,
      width: 48
   },
   actions: {
      justifyContent: 'flex-end'
   },
   avatar: {
      //backgroundColor: "",
   },
   header: {
      textAlign: 'center',
      spacing: 20,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.h4,
      fontWeight: theme.typography.fontWeightMedium,
      //backgroundColor: theme.palette.background.paper,
      letterSpacing: '0.2px'
   }
}));
/*
Funciones y variables auxiliares globales
*/
const rteDefaultValue = {
   key: 'vacio',
   contenido: ''
};

const msgModalInicial = {
   open: false,
   mensaje: '',
   accionAceptar: false,
   aceptarLabel: 'Eliminar'
};
//Queries

const GeneralInformacion = props => {
   const classes = useStyles();
   const cliente = props.data || null;
   /**
    * Estados
    */
   /**
    * Funciones
    */
   const crearDenominacion = () => {
      let denominacion = '';
      if (cliente != undefined && cliente != null) {
         const tipoDocumento = cliente.tipoDoc;
         if (tipoDocumento === '6') {
            denominacion = cliente.razonSocial;
         } else {
            denominacion = `${cliente.nombre} ${cliente.apPaterno} ${cliente.apMaterno}`;
         }
      }
      return denominacion.trim();
   };
   const clienteDen = crearDenominacion();
   return (
      <Card
      /*{...rest}
     className={clsx(classes.root, className)}*/
      >
         <CardHeader
            title={
               <Typography component="p" color="textPrimary" variant="h5">
                  Información general
               </Typography>
            }
            disableTypography={true}
            avatar={
               <Avatar className={classes.avatar}>
                  <BusinessCenterIcon />
               </Avatar>
            }
         />
         <Divider />
         <CardContent className={classes.content}>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {clienteDen}
            </Typography>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {`${
                  cliente.tipoDoc != null
                     ? `${cliente.tipoDoc} - `
                     : 'Sin Nro. Documento Registrado'
               }${cliente.nroDoc || ''}`}
            </Typography>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {`Email: ${cliente.email || 'Sin email registrado'}`}
            </Typography>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {`Teléfono: ${cliente.telefono || 'Sin telefono registrado'}`}
            </Typography>
         </CardContent>
         <Divider />
         <CardActions className={classes.actions}>
            {/*<Button
        startIcon={<EditIcon />}
      >
        Actualizar
      </Button>*/}
         </CardActions>
      </Card>
   );
};

export default GeneralInformacion;
